import React, { useState, useEffect } from 'react';
import { Dialog, Button, DialogTitle, Box, TextField, IconButton } from '@mui/material';

import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import Delete from '@mui/icons-material/Delete';

import { ReactSortable } from "react-sortablejs";

const StyledField = {
    '& .MuiOutlinedInput-root': {
        '& fieldset': {
            borderColor: '#FFFFFF',
        },
        '&:hover fieldset': {
            borderColor: '#F0F0F0',
        },
        '& input[type=number]::-webkit-inner-spin-button': {
            '-webkit-appearance': 'none',
            margin: 0
        }
    },
    '& .MuiInputBase-root.Mui-disabled': {
        '& > fieldset': {
            borderColor: '#F5F5F5',
        }
    }
};

const VEVariablesDialog = ({ open, onClose, variablesObject: jsonData }) => {
    // Local state to keep track of edits and a new entry
    const [data, setData] = useState({ ...jsonData });

    const handleKeyChange = (key, newKey) => {

        if (newKey.match(/[%{}\\$'"<>*?¿!¡@#&|()=/·^ºª`´¨+[\];.,: ]/)) return;

        const newData = {};
        const vars = Object.keys(data);

        for (let i = 0; i < vars.length; i++) {
            if (vars[i] === key) {
                newData[newKey] = data[vars[i]];
            } else {
                newData[vars[i]] = data[vars[i]];
            }
        }

        setData(newData);
    };

    const handleValueChange = (key, newValue) => {
        setData({ ...data, [key]: newValue });
    };

    const handleAddNewRow = () => {
        setData({ ...data, '': '' });
    };

    const handleDeleteRow = (key) => {
        const newData = { ...data };
        delete newData[key];
        setData(newData);
    };

    // Save and close dialog
    const handleSave = () => {
        console.log("handleSave: ", data);
        if ("" in data) {
            delete data[""];
            setData(data);
        }
        onClose(data);
    };

    const onVariablesOrderChange = (event) => {
        console.log("onVariablesOrderChange, from:", event.oldIndex, " to: ", event.newIndex);

        // Reorder keys
        const keys = Object.keys(data);
        const movedKey = keys[event.oldIndex];
        keys.splice(event.oldIndex, 1);
        keys.splice(event.newIndex, 0, movedKey);
        
        // Create new object
        let newData = {};
        for (let i = 0; i < keys.length; i++) {
            newData[keys[i]] = data[keys[i]];
        }
        
        setData(newData);
    };

    return (
        <Dialog open={open} onClose={handleSave} maxWidth="md" fullWidth>
            <DialogTitle>
                <span className="font-bold">Template variables</span>
                <IconButton
                    edge="end"
                    aria-label="close"
                    onClick={handleSave}
                    sx={{ position: 'absolute', right: 20, top: 10 }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <Box className="border-t">
                <Box className="flex bg-gray-100 items-center h-10 border-b">
                    <Box className="w-5"></Box>
                    <Box className="w-1/2 py-2 px-10 font-bold">Variable</Box>
                    <Box className="w-1/2 py-2 px-3 font-bold">Value</Box>
                    <Box className="w-5"></Box>
                </Box>
                <Box className="max-h-80 overflow-auto border-b">
                    <ReactSortable list={Object.keys(data)} setList={() => { }} animation={200} ghostClass="bg-gray-100"
                        onEnd={onVariablesOrderChange}>
                        {
                            Object.entries(data).map(([key, value], index) => (
                                <Box key={index} className="flex items-center border-b min-h-12">
                                    <Box className="w-5 pl-3 cursor-move">
                                        <IconButton className="cursor-move">
                                            <DragIndicatorIcon />
                                        </IconButton>
                                    </Box>
                                    <Box className="flex w-1/2 py-2 px-7">
                                        <TextField
                                            style={{ width: "100%" }}
                                            sx={StyledField}
                                            variant="outlined"
                                            size="small"
                                            autoComplete="off"
                                            fullWidth
                                            value={key}
                                            onChange={(e) => handleKeyChange(key, e.target.value)}
                                        />
                                    </Box>
                                    <Box className="flex w-1/2 py-2 px-5">
                                        <TextField
                                            style={{ width: "100%" }}
                                            sx={StyledField}
                                            variant="outlined"
                                            size="small"
                                            autoComplete="off"
                                            fullWidth
                                            value={value}
                                            multiline
                                            onChange={(e) => handleValueChange(key, e.target.value)}
                                        />
                                    </Box>
                                    <Box>
                                        <IconButton onClick={() => handleDeleteRow(key)}>
                                            <Delete />
                                        </IconButton>
                                    </Box>
                                </Box>
                            ))
                        }
                    </ReactSortable>
                </Box>
            </Box>
            <Box className="pl-3">
                <Button onClick={handleAddNewRow}>
                    <AddIcon />
                    <span className="ml-3 text-sm">Add a new variable</span>
                </Button>
            </Box>
        </Dialog>
    );
};

export default VEVariablesDialog;
